import {
  DashboardOutlined,
  FileTextOutlined,
  MessageOutlined,
  CalendarOutlined,
  TeamOutlined,
  // RobotOutlined,
  SettingOutlined,
  UserOutlined,
  AppstoreOutlined,
  RobotOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";

export const CONSTANTS = {
  INITIAL: "INITIAL",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  WARNING: "WARNING",
  CANCEL: "CANCEL",
};

export const menuItems = [
  { key: "/", icon: <DashboardOutlined />, label: "Tổng quan" },
  { key: "/news", icon: <FileTextOutlined />, label: "Tin tức" },
  { key: "/feedback", icon: <MessageOutlined />, label: "Phản ánh" },
  { key: "/appointments", icon: <CalendarOutlined />, label: "Lịch hẹn" },
  { key: "/areas", icon: <EnvironmentOutlined />, label: "Khu vực địa bàn" },
  { key: "/officers", icon: <UserOutlined />, label: "Cán bộ địa bàn" },
  { key: "/services", icon: <AppstoreOutlined />, label: "Dịch vụ công" },
  { key: "/commitment", icon: <AppstoreOutlined />, label: "Cam kết" },
  { key: "/ai-conversations", icon: <RobotOutlined />, label: "AI Chatbot" },
  {
    key: "/miniapp-accounts",
    icon: <UserOutlined />,
    label: "Tài khoản Miniapp",
  },
  { key: "/users", icon: <TeamOutlined />, label: "Quản lý tài khoản" },
  { key: "/settings", icon: <SettingOutlined />, label: "Cài đặt" },
];

export const BREADCRUMB_MAP = {
  "/": "Tổng quan",
  "/news": "Tin tức",
  "/feedback": "Phản ánh",
  "/appointments": "Lịch tiếp dân",
  "/areas": "Khu vực địa bàn",
  "/officers": "Cán bộ địa bàn",
  "/services": "Dịch vụ công",
  "/commitment": "Cam kết",
  "/ai-conversations": "AI Chatbot",
  "/ai-training": "Training AI",
  "/miniapp-accounts": "Tài khoản Mini App",
  "/roles": "Phân quyền hệ thống",
  "/settings": "Cài đặt",
  "/task-managements": "Quản lý nhiệm vụ",
  "/broadcasts": "Thông báo Broadcast",
};

export const STATUS_LABELS = {
  pending: "Chờ xử lý",
  received: "Đã tiếp nhận",
  assigned: "Đã phân công",
  processing: "Đang xử lý",
  responded: "Đã đóng",
  closed: "Đã đóng",
};

export const STATUS_COLORS = {
  pending: "orange",
  received: "blue",
  assigned: "cyan",
  processing: "geekblue",
  responded: "green",
  closed: "default",
};

export const VARIANT_STYLES = {
  primary: { bg: "#4AA02C", activeBg: "#3E8A25" },
  danger: { bg: "#DC2626", activeBg: "#B91C1C" },
  default: { bg: "#525252", activeBg: "#404040" },
  warning: { bg: "#F59E0B", activeBg: "#D97706" },
  info: { bg: "#2563EB", activeBg: "#1D4ED8" },
};

export const STATUS_MAP = {
  pending: { color: "orange", label: "Chờ xử lý" },
  received: { color: "blue", label: "Đã tiếp nhận" },
  assigned: { color: "cyan", label: "Đã phân công" },
  processing: { color: "geekblue", label: "Đang xử lý" },
  responded: { color: "green", label: "Đã đóng" },
  closed: { color: "default", label: "Đã đóng" },
};

export const TYPE_MAP = {
  security: "An ninh trật tự",
  traffic: "Giao thông",
  environment: "Vệ sinh môi trường",
  urban: "Quản lý đô thị",
  administrative: "Thủ tục hành chính",
  other: "Khác",
};

export const STATUS_APPOINTMENT_MAP = {
  pending: { color: "orange", label: "Chờ duyệt" },
  approved: { color: "green", label: "Đã duyệt" },
  rejected: { color: "red", label: "Từ chối" },
  completed: { color: "blue", label: "Hoàn thành" },
  cancelled: { color: "default", label: "Đã hủy" },
};

export const TYPE_APPOINTMENT_MAP = {
  at_office: "Tại trụ sở",
  at_home: "Tại nhà",
};

export const ListAppointmentsStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  completed: "completed",
  cancelled: "cancelled",
};

export const RANK_OPTIONS = [
  { value: "BINH_NHI", label: "Binh nhì" },
  { value: "BINH_NHAT", label: "Binh nhất" },
  { value: "HOC_VIEN", label: "Học viên" },
  { value: "HA_SI", label: "Hạ sĩ" },
  { value: "TRUNG_SI", label: "Trung sĩ" },
  { value: "THUONG_SI", label: "Thượng sĩ" },
  { value: "THIEU_UY", label: "Thiếu úy" },
  { value: "TRUNG_UY", label: "Trung úy" },
  { value: "THUONG_UY", label: "Thượng úy" },
  { value: "DAI_UY", label: "Đại úy" },
  { value: "THIEU_TA", label: "Thiếu tá" },
  { value: "TRUNG_TA", label: "Trung tá" },
  { value: "THUONG_TA", label: "Thượng tá" },
  { value: "DAI_TA", label: "Đại tá" },
  { value: "THIEU_TUONG", label: "Thiếu tướng" },
  { value: "TRUNG_TUONG", label: "Trung tướng" },
  { value: "THUONG_TUONG", label: "Thượng tướng" },
  { value: "DAI_TUONG", label: "Đại tướng" },
  { value: "KHAC", label: "Khác" },
];

export const POSITION_OPTIONS = [
  { value: "TRUONG_CONG_AN_PHUONG", label: "Trưởng Công an phường" },
  { value: "PHO_TRUONG_CONG_AN_PHUONG", label: "Phó trưởng Công an phường" },
  { value: "TO_TRUONG", label: "Tổ trưởng" },
  { value: "TO_PHO", label: "Tổ phó" },
  { value: "CAN_BO_CHIEN_SI", label: "Cán bộ chiến sĩ" },
];

export const RECIPIENT_LABEL = [
  { value: "TRUONG_CONG_AN_PHUONG", label: "Trưởng Công an phường" },
  { value: "PHO_TRUONG_CONG_AN_PHUONG", label: "Phó trưởng Công an phường" },
  { value: "TO_TRUONG", label: "Tổ trưởng" },
  { value: "TO_PHO", label: "Tổ phó" },
];

export const RECIPIENT_COLOR = {
  TRUONG_CONG_AN_PHUONG: "red",
  PHO_TRUONG_CONG_AN_PHUONG: "orange",
  TO_TRUONG: "blue",
  TO_PHO: "cyan",
};

export const POSITION_ORDER = {
  TRUONG_CONG_AN_PHUONG: 1,
  PHO_TRUONG_CONG_AN_PHUONG: 2,
  TO_TRUONG: 3,
  TO_PHO: 4,
  CAN_BO_CHIEN_SI: 5,
};

export const TEAM_OPTIONS = [
  { value: "TONG_HOP", label: "Tổng hợp", color: "default" },
  { value: "AN_NINH", label: "An ninh", color: "blue" },
  {
    value: "PHONG_CHONG_TOI_PHAM",
    label: "Phòng, chống tội phạm",
    color: "red",
  },
  { value: "TRAN_TU", label: "Trật tự", color: "purple" },
  { value: "CANH_SAT_KHU_VUC", label: "Cảnh sát khu vực", color: "green" },
];

export const RESPONSIBILITY_OPTIONS = [
  "An ninh",
  "Trật tự",
  "Cảnh sát khu vực",
  "Phòng chống tội phạm",
  "Tổng hợp",
];

export const ROLE_COLORS = {
  TRUONG_CONG_AN_PHUONG: "red",
  PHO_TRUONG_CONG_AN_PHUONG: "volcano",
  TO_TRUONG: "orange",
  TO_PHO: "green",
  CAN_BO_CHIEN_SI: "blue",
};

export const ROLE_LABELS = {
  TRUONG_CONG_AN_PHUONG: "Trưởng Công an phường",
  PHO_TRUONG_CONG_AN_PHUONG: "Phó trưởng Công an phường",
  TO_TRUONG: "Tổ trưởng",
  TO_PHO: "Tổ phó",
  CAN_BO_CHIEN_SI: "Cán bộ chiến sĩ",
};

export const MODULE_OPTIONS = [
  { label: "Tin tức", value: "news" },
  { label: "Phản ánh", value: "feedback" },
  { label: "Lịch hẹn", value: "appointments" },
  { label: "Khu vực địa bàn", value: "areas" },
  { label: "Cán bộ địa bàn", value: "officers" },
  { label: "Dịch vụ công", value: "services" },
  { label: "Quản lý tài khoản", value: "users" },
  { label: "Cài đặt", value: "settings" },
];

export const AREA_COLORS = [
  "#E53935", // Đỏ
  "#1E88E5", // Xanh dương
  "#43A047", // Xanh lá
  "#FB8C00", // Cam
  "#8E24AA", // Tím
  "#00897B", // Xanh mòng két
  "#D81B60", // Hồng
  "#3949AB", // Xanh chàm
  "#7CB342", // Xanh lục nhạt
  "#6D4C41", // Nâu
  "#00ACC1", // Xanh lơ
];

export const ACTION_LABELS = {
  RECEIVED: "Đã gửi phản ánh",
  ASSIGNED: "Đã phân công",
  ACCEPTED: "Đã tiếp nhận",
  PROCESSING: "Bắt đầu xử lý",
  FORWARDED: "Đã chuyển tiếp",
  PROPOSED_TO_CHIEF: "Đã đề xuất chỉ huy",
  COLLABORATION_REQUESTED: "Đã mời phối hợp",
  REINFORCED: "Đã tăng cường lực lượng",
  PROPOSAL_ACCEPTED: "Đã nhận điều phối",
  COLLABORATION_ACCEPTED: "Đã tiếp nhận phối hợp",
  COLLABORATION_FORWARDED: "Đã chuyển tiếp phối hợp",
  RESOLVED: "Đã xử lý xong",
  RESPONDED: "Đã hoàn thành",
  REJECTED: "Từ chối xử lý",
  ESCALATED: "Cảnh báo leo thang",
  COMMENTED: "Đã cập nhật tiến độ",
  UPDATED: "Đã cập nhật",
  DIRECTIVE: "Chỉ đạo",
  SLA_BREACH: "Quá hạn tiếp nhận",
};

export const STATUS_MAP_FEEDBACK = {
  PENDING: {
    color: "default",
    label: "Chờ xử lý",
    tooltip: "Phản ánh đang chờ hệ thống xử lý",
  },
  RECEIVED: {
    color: "cyan",
    label: "Mới nhận",
    tooltip: "Phản ánh mới nhận từ công dân",
  },
  ASSIGNED: {
    color: "gold",
    label: "Chờ tiếp nhận",
    tooltip: "Đã phân công, đang đợi cán bộ tiếp nhận",
  },
  ACCEPTED: {
    color: "blue",
    label: "Đã tiếp nhận",
    tooltip: "Cán bộ đã tiếp nhận vụ việc",
  },

  PROCESSING: {
    color: "geekblue",
    label: "Đang xử lý",
    tooltip: "Cán bộ đang xử lý vụ việc",
  },
  RESPONDED: {
    color: "green",
    label: "Đã phản hồi",
    tooltip: "Đã phản hồi cho công dân",
  },
  CLOSED: {
    color: "default",
    label: "Đã đóng",
    tooltip: "Vụ việc đã kết thúc",
  },
};

export const PRIORITY_MAP_FEEDBACK = {
  LOW: { color: "default", label: "Thấp" },
  MEDIUM: { color: "blue", label: "Trung bình" },
  HIGH: { color: "orange", label: "Cao" },
  URGENT: { color: "red", label: "Khẩn cấp" },
};

export const CATEGORY_MAP_FEEDBACK = {
  TONG_HOP: { label: "Tổng hợp", color: "default" },
  AN_NINH: { label: "An ninh", color: "volcano" },
  PHONG_CHONG_TOI_PHAM: { label: "Phòng, chống tội phạm", color: "magenta" },
  CANH_SAT_KHU_VUC: { label: "Cảnh sát khu vực", color: "green" },
  TRAN_TU: { label: "Trật tự", color: "orange" },
};

export const COMMITMENT_STATUS = {
  DRAFT: "draft",
  APPLIED: "applied",
};
export const COMMITMENT_STATUS_OPTIONS = [
  { value: COMMITMENT_STATUS.APPLIED, label: "Đang áp dụng" },
  { value: COMMITMENT_STATUS.DRAFT, label: "Bản nháp" },
  // { value: "inactive", label: "Ngừng áp dụng" },
];
export const PAGE_SIZE = 20;
export const NUMBER_CONTROL_KEYS = [
  "Backspace",
  "Delete",
  "Tab",
  "Escape",
  "Enter",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
];

export const PRIORITY_MAP = {
  LOW: { color: "default", label: "Thấp" },
  MEDIUM: { color: "blue", label: "Trung bình" },
  HIGH: { color: "orange", label: "Cao" },
  URGENT: { color: "red", label: "Khẩn cấp" },
};

export const ENUM_ROLE = {
  TRUONG_CONG_AN_PHUONG: "TRUONG_CONG_AN_PHUONG",
  PHO_TRUONG_CONG_AN_PHUONG: "PHO_TRUONG_CONG_AN_PHUONG",
  TO_TRUONG: "TO_TRUONG",
  TO_PHO: "TO_PHO",
  CAN_BO_CHIEN_SI: "CAN_BO_CHIEN_SI",
};

export const ENUM_AUDIT_LOG_ACTOR_ROLE = {
  OFFICER: "officer",
  TEAM_LEADER: "team_leader",
  DEPUTY_CHIEF: "deputy_chief",
  CHIEF: "chief",
  ADMIN: "admin",
  SYSTEM: "system",
};

export const ENUM_AUDIT_LOG_EVENT_GROUP = {
  AUTH: "AUTH",
  ACCOUNT: "ACCOUNT",
  CONFIG: "CONFIG",
  BUSINESS: "BUSINESS",
};

export const ENUM_AUDIT_LOG_EVENT_TYPE = {
  LOGIN_SUCCESS: "login_success",
  LOGIN_FAILED: "login_failed",
  ACCOUNT_LOCKED: "account_locked",
  LOGOUT: "logout",
  PASSWORD_CHANGED: "password_changed",
  PASSWORD_RESET: "password_reset",
  USER_CREATED: "user_created",
  USER_UPDATED: "user_updated",
  ROLE_CHANGED: "role_changed",
  ROLE_CONFIG_CHANGED: "role_config_changed",
  USER_STATUS_CHANGED: "user_status_changed",
  TDP_ASSIGNMENT_CHANGED: "tdp_assignment_changed",
  SLA_CONFIG_CHANGED: "sla_config_changed",
  TDP_CHANGED: "tdp_changed",
  UNIT_INFO_CHANGED: "unit_info_changed",
  CATEGORY_CHANGED: "category_changed",
  PUBLIC_SERVICE_CHANGED: "public_service_changed",
  DATA_IMPORT_EXPORT: "data_import_export",
  PRIORITY_OVERRIDDEN: "priority_overridden",
  FEEDBACK_REASSIGNED: "feedback_reassigned",
  BROADCAST_SENT: "broadcast_sent",
  REPORT_EXPORTED: "report_exported",
  CITIZEN_DATA_VIEWED: "citizen_data_viewed",
};

export const AUDIT_LOG_EVENT_TYPE_LABELS = {
  login_success: "Đăng nhập thành công",
  login_failed: "Đăng nhập thất bại",
  account_locked: "Tài khoản bị khóa",
  logout: "Đăng xuất",
  password_changed: "Đổi mật khẩu",
  password_reset: "Đặt lại mật khẩu",
  user_created: "Tạo tài khoản",
  user_updated: "Cập nhật tài khoản",
  role_changed: "Thay đổi vai trò",
  role_config_changed: "Thay đổi vai trò và ma trận phân quyền",
  user_status_changed: "Thay đổi trạng thái tài khoản",
  tdp_assignment_changed: "Thay đổi phân công TDP",
  sla_config_changed: "Cập nhật cấu hình SLA",
  tdp_changed: "Thay đổi TDP",
  unit_info_changed: "Cập nhật thông tin đơn vị",
  category_changed: "Thay đổi danh mục",
  public_service_changed: "Thay đổi dịch vụ công",
  data_import_export: "Nhập/Xuất dữ liệu",
  priority_overridden: "Điều chỉnh độ ưu tiên",
  feedback_reassigned: "Điều chuyển phản ánh",
  broadcast_sent: "Gửi thông báo",
  report_exported: "Xuất báo cáo",
  citizen_data_viewed: "Xem dữ liệu công dân",
};
